module.exports = __webpack_public_path__ + "img/image-mutenmaru.c632dd70.png";